import React from "react";
import { Route, Routes } from "react-router-dom";

import Campaign from "@/components/screens/Campaign";
import CampaignFormPage from "@/components/screens/CampaignFormPage";
import CampaignLogsPage from "@/components/screens/CampaignLogsPage";
import CampaignStatisticsPage from "@/components/screens/CampaignStatisticsPage";
import { CAMPAIGN_FORM_PAGE_MESSAGES } from "@/messages/campaigns/campaign-form-page.messages";
import { CAMPAIGNS_MESSAGES } from "@/messages/campaigns/campaigns.messages";
import { CAMPAIGN_LOG_MESSAGES } from "@/messages/campaigns/logs/campaign-logs.messages";
import { STATISTICS_PAGE_MESSAGES } from "@/messages/campaigns/statistics/statistics-page.messages";

const CampaignsPage: React.FC = () => {
  return (
    <Routes>
      <Route path="/:lang" element={<Campaign messages={CAMPAIGNS_MESSAGES} />} />
      <Route
        path="/create/:lang"
        element={<CampaignFormPage messages={CAMPAIGN_FORM_PAGE_MESSAGES} />}
      />
      <Route
        path="/update/:campaignId/:lang"
        element={<CampaignFormPage messages={CAMPAIGN_FORM_PAGE_MESSAGES} isEditing />}
      />
      <Route
        path="/statistics/:campaignId/:lang"
        element={<CampaignStatisticsPage messages={STATISTICS_PAGE_MESSAGES} />}
      />
      <Route
        path="/statistics/details/:campaignId/:scheduleDate/:lang"
        element={<CampaignLogsPage messages={CAMPAIGN_LOG_MESSAGES} />}
      />
      <Route
        path="/logs/:campaignId/:lang"
        element={<CampaignLogsPage messages={CAMPAIGN_LOG_MESSAGES} />}
      />
      <Route path="/" element={<Campaign messages={CAMPAIGNS_MESSAGES} />} />
    </Routes>
  );
};

export default CampaignsPage;
